interface SelectableItem {
    isSelected: boolean;
    filePath: string;
}

export const getSelectedItems = <T extends SelectableItem>(items: T[] | undefined): T[] => {
    return items?.filter(item => item.isSelected) || [];
};

export const getResources = (environment: string, dynamicStateObjectRef: any, vscode: any, settingsObjRef?: any) => {
    const focusedFile = dynamicStateObjectRef.current.focusedFile;
    const selectedAdditionalIdeContext = dynamicStateObjectRef.current.selectedAdditionalIdeContext;
    const openFileStatuses = dynamicStateObjectRef.current.openFileStatuses;

    // Get selected files from both sources
    const selectedOpenFiles = openFileStatuses
        .filter((file: { isSelected: boolean }) => file.isSelected)
        .map((file: { filePath: string }) => file.filePath);
    const selectedContextFiles = getSelectedItems(selectedAdditionalIdeContext?.files)
        .map(file => file.filePath);

    // Combine files and ensure uniqueness
    const filesToSendSet = new Set([...selectedOpenFiles, ...selectedContextFiles]);
    if (focusedFile !== null && openFileStatuses.length > 0) {
        filesToSendSet.add(focusedFile);
    }
    const filesToSend = Array.from(filesToSendSet);

    // Get selected folders
    const foldersToSend = getSelectedItems(selectedAdditionalIdeContext?.folders)
        .map(folder => folder.filePath);

    // Get scrape settings and convert to strings
    const scrapeErrors = (settingsObjRef?.current?.scrapeErrors ?? false).toString();
    const scrapeWarnings = (settingsObjRef?.current?.scrapeWarnings ?? false).toString();

    if (environment.includes("jetbrains")) {
        window.jetbrainsPostMessage(JSON.stringify({
            functionName: "getResources",
            data: [{
                selectedFiles: JSON.stringify(filesToSend),
                selectedFolders: JSON.stringify(foldersToSend),
                scrapeErrors: scrapeErrors,
                scrapeWarnings: scrapeWarnings
            }]
        }));
    } else if (environment === "vscode") {
        vscode.postMessage({
            functionName: "getResources",
            data: [{
                selectedFiles: filesToSend,
                selectedFolders: foldersToSend,
                scrapeErrors: scrapeErrors,
                scrapeWarnings: scrapeWarnings
            }]
        });
    } else if (environment === "chrome") {
        window.parent.postMessage({
            functionName: "getResources",
            data: [{_: "_"}]
        }, '*');
    }
}